import { Table } from "antd";
import Moment from "moment";
// import newdelete from "../../assets/svg/newdelete.svg";
import featuredImage from "../../assets/images/featured-image.PNG";
import Actions from "../../components/Common/Actions";
import scroll from "../../assets/webp/scroll.webp";

const HealthArticleTable = ({
  records,
  skip,
  handleActive,
  setId,
  setDel,
  handleEdit,
  handleView,
  loader,
}) => {
  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      fixed: "left",
      render: (text, record, index) => skip + (index + 1),
    },
    {
      title: "Title",
      dataIndex: "title",
      fixed: "left",
      width: 400,
    },
    {
      title: "Menu",
      dataIndex: "menu",
      width: 150,
    },
    {
      title: "Category",
      dataIndex: "category",
      width: 150,
    },
    {
      title: "Likes",
      dataIndex: "likes",
      width: 100,
    },
    {
      title: "Dislikes",
      dataIndex: "dislikes",
      width: 100,
    },
    {
      title: "Date of Publishing",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD MMMM YYYY"),
      width: 180,
    },
    {
      title: "Time",
      dataIndex: "createdAt",
      render: (text) => `${Moment(text).format("LT")} (IST)`,
      width: 150,
    },
    {
      title: "Trending",
      dataIndex: "trendingblog",
      render: (text) => text || "-",
      width: 120,
    },
    {
      title: "Spotlight",
      dataIndex: "topicmonth",
      render: (text) => (text ? "Yes" : "No"),
      width: 120,
    },
    {
      title: "Featured Images",
      dataIndex: "featuredImage",
      render: () => <img src={featuredImage} alt="" />,
      // width: 150,
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (text) => (text ? "Active" : "Inactive"),
      width: 150,
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Actions
          isEdit={true}
          isView={true}
          recordActiveStatus={record.active}
          isDelete={true}
          isActive={true}
          onClickView={() => handleView(record.slugurl)}
          onClickEdit={() => handleEdit(record.slugurl)}
          onClickDelete={() => {
            setId(record._id);
            setDel(true);
          }}
          onClickActive={() => handleActive(record._id, record.active)}
        />
      ),
    },
  ];

  const dataSource = records.filter(
    (x) => x.show === undefined || x.show === true,
  );
  return (
    <>
      {!loader ? (
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}
    </>
  );
};

export default HealthArticleTable;
